"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOX_CONTAINER_SELECTED_BORDER_WIDTH = exports.BOX_CONTAINER_BORDER_WIDTH = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
const BOX_CONTAINER_BORDER_WIDTH = exports.BOX_CONTAINER_BORDER_WIDTH = (0, _utils.token)('dimensions.border.width.100');
const BOX_CONTAINER_SELECTED_BORDER_WIDTH = exports.BOX_CONTAINER_SELECTED_BORDER_WIDTH = (0, _utils.token)('dimensions.border.width.200');